import _extends from"@babel/runtime/helpers/extends";var _this=this,_jsxFileName="/home/travis/build/24i/prj-aeroverse/src/aeroverse/pages/_app.js";import React from'react';
import{useTranslation}from'react-i18next';
import'@adyen/adyen-web/dist/adyen.css';
import'react-loading-skeleton/dist/skeleton.css';

import App from"../app";

var footerIcons=[
{
font:'fontAwesome',
name:'instagram',
href:'https://www.instagram.com/the.aeroverse'
},
{
font:'fontAwesome',
name:'facebook',
href:'https://www.facebook.com/TheAeroverse'
},
{
font:'fontAwesome',
name:'linkedin',
href:'https://www.linkedin.com/company/aeroversetv'
},
{
font:'fontAwesome',
name:'home',
href:'/'
}];


var WebApp=function WebApp(props){
var _useTranslation=useTranslation(['sott']),t=_useTranslation.t;

var footerLinks=[
{title:t('footer.contactUs'),href:'https://www.24i.com/contact/'},
{title:t('footer.news'),href:'https://www.24i.com/articles/'}];


return React.createElement(App,_extends({footerLinks:footerLinks,footerIcons:footerIcons},props,{__self:_this,__source:{fileName:_jsxFileName,lineNumber:39,columnNumber:12}}));
};

export default WebApp;